import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { HeaderSpinnerService } from '../../services/header.spinner.service';

let activeRequests = 0;

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const headerSpinnerService = inject(HeaderSpinnerService);

  activeRequests++;
  if (activeRequests === 1) {
    headerSpinnerService.show();
  }

  return next(req).pipe(
    finalize(() => {
      activeRequests--;
      if (activeRequests === 0) {
        headerSpinnerService.hide();
      }
    })
  );
};
